/**
 * assets/customizer-tote.js
 * Tote-specific customization logic.
 */
class ToteCustomizer extends ColorCustomizer {
  constructor(config) {
    super(config);
    window.selectedSmallToteColor = 'white';
    window.selectedSmallToteVariantId = '';
    
    // Variant maps
    this.variantToColorMap = config.variantToColorMap || {
      '47336595325118': 'white',
      '47336595357886': 'pink',
      '47336595390654': 'black',
      '47597920190654': 'white',
      '47597920256190': 'pink',
      '47597920288958': 'black',
      '47597920321726': 'white',
      '47597920354494': 'pink',
      '47597920387262': 'black'
    };
    
    this.smallToteDtfVariantId = config.smallToteDtfVariantId || '47597933396158';
  }

  get selectedSmallToteColor() { return window.selectedSmallToteColor; }
  set selectedSmallToteColor(val) { window.selectedSmallToteColor = val; }

  get selectedSmallToteVariantId() { return window.selectedSmallToteVariantId; }
  set selectedSmallToteVariantId(val) { window.selectedSmallToteVariantId = val; }

  getVariantColor(v) {
    if (!v) return '';
    if (this.variantToColorMap && this.variantToColorMap[v.id]) {
      return this.variantToColorMap[v.id].toLowerCase();
    }
    if (window.VARIANT_TO_COLOR_MAP && window.VARIANT_TO_COLOR_MAP[v.id]) {
      return window.VARIANT_TO_COLOR_MAP[v.id].toLowerCase();
    }
    if (typeof window.parseVariantTitle === 'function' && v.title) {
      const parsed = window.parseVariantTitle(v.title);
      if (parsed && parsed.color) return parsed.color.toLowerCase();
    }
    if (v.title) {
      const titleLower = v.title.toLowerCase();
      const knownColors = ['white', 'pink', 'black', 'blue', 'dusty blue', 'heather yellow gold', 'heather red', 'navy', 'gray', 'grey', 'green', 'sage', 'yellow', 'red', 'oatmeal', 'beige', 'purple'];
      for (const color of knownColors) {
        if (titleLower.includes(`color-${color}`) || titleLower.includes(`(${color})`) || titleLower.includes(`-${color}`) || titleLower.includes(` ${color}`)) {
          return color;
        }
      }
    }
    return '';
  }

  bindGlobalMethods() {
    super.bindGlobalMethods();
    window.renderSmallTotePicker = () => this.renderSmallTotePicker();
    window.selectSmallToteColor = (color) => this.selectSmallToteColor(color);
    window.selectSmallToteVariant = (id) => this.selectSmallToteVariant(id);
    window.syncSmallToteVariant = (id) => this.syncSmallToteVariant(id);
    window.onSmallToteDropdownChange = (e) => this.onSmallToteDropdownChange(e);
    window.parseSmallToteVariant = (v) => this.parseSmallToteVariant(v);
    window.getSmallToteVariantColor = (v) => this.getVariantColor(v);
  }

  renderSmallTotePicker() {
    const container = document.querySelector('.small-tote-variant-selectors');
    if (!container) return;
    
    const colors = ['white', 'pink', 'black'];
    const activeColorDetails = this.colorDetails[this.selectedSmallToteColor] || { name: this.selectedSmallToteColor };
    const activeName = activeColorDetails.name;

    const selectedColorText = document.getElementById('small-tote-selected-color-text');
    if (selectedColorText) {
      selectedColorText.innerText = activeName;
    }

    const activeVariantId = String(this.selectedSmallToteVariantId || document.getElementById('small-tote-hidden-variant-input')?.value || '');

    const colorFieldset = container.querySelector('.small-tote-color-option');
    if (colorFieldset) {
      const activeVar = window.productVariants.find(v => String(v.id) === activeVariantId) || window.productVariants[0];
      
      let showColors = true;
      if (activeVar) {
        const parsed = window.parseVariantTitle(activeVar.title);
        if (parsed && parsed.style && (parsed.style.toLowerCase().includes('dtf transfer sheet') || parsed.style.toLowerCase().includes('dtf transfer') || parsed.style.toLowerCase() === 'dtf')) {
          showColors = false;
        }
      }
      colorFieldset.style.display = showColors ? '' : 'none';
    }
    
    const colorContainer = document.getElementById('small-tote-color-swatches');
    if (colorContainer) {
      colorContainer.innerHTML = colors.map(color => {
        const isActive = this.selectedSmallToteColor === color;
        const details = this.colorDetails[color] || { name: color, hex: '#ccc', border: '#ccc' };
        
        // Check if this color is sold out for the selected style/pack option
        const activeVar = window.productVariants.find(v => String(v.id) === activeVariantId) || window.productVariants[0];
        const activeStyleName = activeVar ? (window.parseVariantTitle(activeVar.title).style || activeVar.title) : '';
        const matchVarForStyle = window.productVariants.find(v => {
          const parsed = window.parseVariantTitle(v.title);
          const styleName = parsed.style || v.title;
          return this.getVariantColor(v) === color && styleName === activeStyleName;
        });
        const isSoldOut = matchVarForStyle ? !matchVarForStyle.available : true;

        return `
          <div class="color-swatch-item ${isActive ? 'active' : ''} ${isSoldOut ? 'sold-out-slashed' : ''}" 
               onclick="window.selectSmallToteColor('${color}')"
               onmouseover="const el = document.getElementById('small-tote-selected-color-text'); if(el) el.innerText = '${details.name}';"
               onmouseout="const el = document.getElementById('small-tote-selected-color-text'); if(el) el.innerText = '${activeName}';"
               style="display: flex; align-items: center; justify-content: center; cursor: pointer; position: relative;"
               title="${details.name}${isSoldOut ? ' (Sold Out)' : ''}">
            <div class="color-swatch-circle" style="width: 28px; height: 28px; border-radius: 50%; background: ${details.hex}; border: 1px solid ${details.border}; position: relative; ${isActive ? 'box-shadow: 0 0 0 2px #fff, 0 0 0 3px #6e8efb;' : ''}">
              ${isActive ? '<div style="position: absolute; top: -2px; right: -2px; background: #6e8efb; color: white; border-radius: 50%; width: 12px; height: 12px; display: flex; align-items: center; justify-content: center; font-size: 7px; border: 1px solid #fff;">✓</div>' : ''}
            </div>
          </div>
        `;
      }).join('');
    }

    const purchaseContainer = document.getElementById('small-tote-purchase-buttons');
    if (purchaseContainer) {
      const selectedColor = this.selectedSmallToteColor;
      const relevantVariants = window.productVariants.filter(v => {
        if (this.getVariantColor(v) === selectedColor) return true;
        if (String(v.id) === String(this.smallToteDtfVariantId)) return true;
        return false;
      });

      const buttonVariants = relevantVariants.filter(v => {
        return !v.title.toLowerCase().includes('physical tote - set of');
      });

      const dropdownVariants = relevantVariants.filter(v => {
        return v.title.toLowerCase().includes('physical tote - set of');
      });

      const buttonsHtml = buttonVariants.map(v => {
        const isActive = activeVariantId === String(v.id);
        const parsed = window.parseVariantTitle(v.title);
        const styleName = parsed.style || v.title;
        const isSoldOut = !v.available;
        return `
          <button type="button" class="variant-option__button-label ${isActive ? 'active-style' : ''} ${isSoldOut ? 'sold-out-slashed' : ''}" 
                  onclick="window.selectSmallToteVariant('${v.id}')"
                  style="flex: 1 1 calc(50% - 6px); min-width: calc(50% - 6px); padding: 12px 6px; min-height: 64px; border: 1px solid ${isActive ? 'var(--color-foreground)' : '#e5e7eb'}; border-radius: var(--style-border-radius-buttons-primary, 40px); background-color: ${isActive ? 'rgb(var(--color-foreground-rgb))' : '#fff'}; color: ${isActive ? 'var(--color-background)' : 'var(--color-foreground)'}; cursor: pointer; transition: all 0.2s; text-align: center; font-size: 0.95rem; font-weight: 500;">
            <span class="variant-option__button-title" style="display: block; font-weight: 500; font-size: 0.95rem; line-height: 1.2;">${styleName}</span>
            <span class="variant-option__button-price" style="font-size: 0.85rem; font-weight: 600; opacity: 0.75; display: block; margin-top: 4px;">${isSoldOut ? 'Sold Out' : window.formatMoney(v.price)}</span>
          </button>
        `;
      }).join('');

      let dropdownHtml = '';
      if (dropdownVariants.length > 0) {
        const isDropdownSelected = dropdownVariants.some(v => String(v.id) === activeVariantId);
        const dropdownLabel = 'Buy More & Save...';
        
        // Find single physical tote variant for current color
        const singleToteVar = buttonVariants.find(v => !v.title.toLowerCase().includes('dtf')) || buttonVariants[0];
        const singleToteId = singleToteVar ? singleToteVar.id : '';

        dropdownHtml = `
          <div class="variant-option__dropdown-wrapper">
            <select id="small-tote-pack-dropdown" 
                    class="variant-option__dropdown ${isDropdownSelected ? 'is-selected' : ''}"
                    onchange="window.onSmallToteDropdownChange(this)">
              <option value="${singleToteId}" ${!isDropdownSelected ? 'selected' : ''}>${dropdownLabel}</option>
              ${dropdownVariants.map(v => {
                const parsed = window.parseVariantTitle(v.title);
                const packName = parsed.style || v.title;
                const isSelected = activeVariantId === String(v.id);
                const isSoldOut = !v.available;
                return `<option value="${v.id}" ${isSelected ? 'selected' : ''} ${isSoldOut ? 'disabled' : ''}>${packName} (${window.formatMoney(v.price)})${isSoldOut ? ' - Sold Out' : ''}</option>`;
              }).join('')}
            </select>
          </div>
        `;
      }

      purchaseContainer.innerHTML = `
        <div style="display: flex; flex-wrap: wrap; gap: 10px; width: 100%;">
          ${buttonsHtml}
        </div>
        ${dropdownHtml}
      `;
    }
  }

  selectSmallToteColor(color) {
    this.selectedSmallToteColor = color;
    
    const customization = this.allCustomizations[this.selectedCustomizationIndex];
    if (customization && customization.key) {
      let gKey = customization.key;
      const lastDashIndex = gKey.lastIndexOf('-');
      if (lastDashIndex !== -1) {
        gKey = gKey.substring(0, lastDashIndex);
      }
      window.updateProductColor(color, gKey);
    }

    const currentVarId = String(this.selectedSmallToteVariantId || '');
    const isDTF = currentVarId === this.smallToteDtfVariantId;
    
    if (!isDTF) {
      this.syncSmallToteVariant();
    }
    this.renderSmallTotePicker();
  }

  selectSmallToteVariant(variantId) {
    this.syncSmallToteVariant(variantId);
    this.renderSmallTotePicker();
  }

  onSmallToteDropdownChange(selectElement) {
    const val = selectElement.value;
    if (val) {
      this.syncSmallToteVariant(val);
      this.renderSmallTotePicker();
    }
  }

  syncSmallToteVariant(variantId) {
    let matchVar = null;
    if (variantId) {
      matchVar = window.productVariants.find(v => String(v.id) === String(variantId));
    } else {
      // Find current style (single, set of 2, etc.) to preserve it across color changes
      const currentVar = window.productVariants.find(v => String(v.id) === String(this.selectedSmallToteVariantId));
      const currentParsed = currentVar ? this.parseSmallToteVariant(currentVar) : null;
      const currentStyle = currentParsed ? currentParsed.style : 'single';
      
      matchVar = window.productVariants.find(v => {
        const p = this.parseSmallToteVariant(v);
        return p.color === this.selectedSmallToteColor && p.style === currentStyle;
      }) || window.productVariants.find(v => {
        return this.getVariantColor(v) === this.selectedSmallToteColor && !v.title.toLowerCase().includes('physical tote - set of');
      }) || window.productVariants.find(v => {
        return this.getVariantColor(v) === this.selectedSmallToteColor;
      });
    }

    if (matchVar) {
      this.selectedSmallToteVariantId = matchVar.id;
      const matchedColor = this.getVariantColor(matchVar);
      if (matchedColor) {
        this.selectedSmallToteColor = matchedColor;
      }

      const hiddenInput = document.getElementById('small-tote-hidden-variant-input');
      if (hiddenInput) {
        hiddenInput.value = matchVar.id;
      }

      const mainProductForm = document.querySelector('form[action$="/cart/add"]');
      if (mainProductForm) {
        const mainVariantInput = mainProductForm.querySelector('input[name="id"]');
        if (mainVariantInput) {
          mainVariantInput.value = matchVar.id;
          mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      try {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchVar.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        console.warn("Could not update variant URL param", e);
      }

      const customization = this.allCustomizations[this.selectedCustomizationIndex];
      if (customization && String(matchVar.id) !== String(this.smallToteDtfVariantId)) {
        let gKey = customization.key;
        const lastDashIndex = gKey.lastIndexOf('-');
        if (lastDashIndex !== -1) {
          gKey = gKey.substring(0, lastDashIndex);
        }
        
        // Update all items in this design set locally and update DOM in-place to prevent jank
        this.allCustomizations.forEach((item, idx) => {
          if (item.key === gKey || (item.key && item.key.startsWith(gKey + '-'))) {
            item.variantId = matchVar.id;
            if (window.getUpdatedProductUrl) {
              item.imageUrl = window.getUpdatedProductUrl(item.imageUrl, matchVar.id);
            }
            
            const card = document.querySelector(`.custom-item-card[data-index="${idx}"]`);
            if (card) {
              const img = card.querySelector('.item-thumb-container img');
              if (img) img.src = item.imageUrl;
              const thumb = card.querySelector('.item-thumb-container');
              if (thumb) thumb.setAttribute('onclick', `window.openImageZoom('${item.imageUrl}')`);
            }
          }
        });
        
        if (this.updateRemoteHistoryItem) {
          this.updateRemoteHistoryItem(gKey, { variantId: matchVar.id });
        }
        
        if (window.updateBuyButtonVisibility) {
          window.updateBuyButtonVisibility();
        }
      }

      if (window.updateLivePrice) window.updateLivePrice();
    }
  }

  updateColorVariants() {
    const customization = this.allCustomizations[this.selectedCustomizationIndex];
    
    let defaultId = this.aiImagePath === 'small-tote' ? "47336595325118" : "46660417421502";
    let targetId = customization ? (customization.variantId || defaultId) : defaultId;
    
    if (this.aiImagePath === 'small-tote') {
      const activeVar = window.productVariants.find(v => String(v.id) === String(targetId)) || window.productVariants[0];
      if (activeVar) {
        let activeColor = this.getVariantColor(activeVar);
        if (!activeColor && customization && customization.key) {
          let gKey = customization.key;
          const lastDashIndex = gKey.lastIndexOf('-');
          if (lastDashIndex !== -1) {
            gKey = gKey.substring(0, lastDashIndex);
          }
          activeColor = window.productGroupColors[gKey];
        }
        this.selectedSmallToteColor = activeColor || 'white';
        this.selectedSmallToteVariantId = activeVar.id;

        // Sync inputs
        const hiddenInput = document.getElementById('small-tote-hidden-variant-input');
        if (hiddenInput) {
          hiddenInput.value = activeVar.id;
        }
        const mainProductForm = document.querySelector('form[action$="/cart/add"]');
        if (mainProductForm) {
          const mainVariantInput = mainProductForm.querySelector('input[name="id"]');
          if (mainVariantInput) {
            mainVariantInput.value = activeVar.id;
          }
        }
      }
      this.renderSmallTotePicker();
      const color = this.selectedSmallToteColor;
      const allowedIds = window.productVariants
        .filter(v => this.getVariantColor(v) === color)
        .map(v => String(v.id));

      if (customization) {
        window.filterVariants([...allowedIds, String(this.smallToteDtfVariantId)]);
      } else {
        window.resetVariantVisibility();
      }
    } else {
      if (customization) {
        window.filterVariants([targetId]);
      } else {
        window.resetVariantVisibility();
      }
    }
  }

  parseSmallToteVariant(v) {
    if (!v) return { color: '', style: 'single' };
    const color = this.getVariantColor(v);
    let style = 'single';
    
    if (String(v.id) === String(this.smallToteDtfVariantId)) {
      style = 'dtf';
    } else {
      const match = v.title.match(/set of \d+/i);
      if (match) {
        style = match[0].toLowerCase();
      }
    }
    return { color, style };
  }
}
